import Breadcrumbs from "@base/Breadcrumbs/Breadcrumbs";

export default Breadcrumbs;
